module.exports = __webpack_public_path__ + "static/media/image28.2229983d.jpg";